export default __webpack_public_path__ + "static/media/click-right.9e406344.svg";